import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Typography from '@material-ui/core/Typography';
import StepButton from '@material-ui/core/StepButton/StepButton';
import CreatePin from '../People/CreatePin';
import ReactSelect from '../../components/Select';
// import Grid from '@material-ui/core/Grid/Grid';
// import ButtonSubmit from '../../components/ButtonSubmit';
// import SelectPerson from './SelectPerson';
// import _Helper from '../../_Helper';
import HttpClient from '../../myapi';
import _Helper from '../../_Helper';
import ButtonSubmit from '../../components/ButtonSubmit';
import Rupee from '../../components/Rupee';
// import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import FormControl from '@material-ui/core/FormControl/FormControl';
import TextField from '@material-ui/core/TextField/TextField';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid/Grid';
import { MsgError } from '../../components/Message';

const styles = theme => ({
    root: {
        // width: '90%',
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    marginTop: {
        marginTop: 10,
    },
    tabContainer: {
        minHeight: 100
    },
});

class PinStepper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            newpin: '',
            amount: '',
            pinOwner: {},
            parentPins: [],
            selectPinOpts: [],
            parentPin: {},
            processing: false,
            failed: false
        };
    }
    componentDidMount() {
        console.log('yep');

        this.getUsedPins();
        this.getNewPin();
    }

    getNewPin() {
        HttpClient.get('/Pins/generatePin').then(res => {
            this.setState({
                newpin: res,
            });
        });
    }

    getUsedPins() {
        HttpClient.get('/Pins/getPins').then(res => {
            const tmp = res.map(pin => {
                return {
                    label: pin.pin,
                    value: pin.pid,
                };
            });
            this.setState({
                parentPins: res,
                selectPinOpts: tmp,
            });
        });
    }

    handleStep = step => {
        this.setState({
            activeStep: step,
        });
    };

    handleNext = () => {
        this.setState(state => ({
            activeStep: state.activeStep + 1,
        }));
    };

    personSelected = person => {
        this.setState({
            pinOwner: {
                id: person.value,
                name: person.label,
            },
        });
    };

    pinSelected = pin => {
        const originalPin = _Helper.searchRecord(
            this.state.parentPins,
            'pid',
            pin.value
        );
        this.setState({
            parentPin: originalPin,
        });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    submit = () => {
        this.setState({
            processing: true,
        });
        const send = {
            action: 1,
            newpin: this.state.newpin,
            newpinOwnr: this.state.pinOwner.id,
            prntPin: this.state.parentPin.pid,
            amount: this.state.amount
        };
        HttpClient.post('/Pins/savePin', send).then(res => {
            if (res === '*') {
                this.setState({
                    processing: false,
                    success: true,
                    activeStep: 2,
                });
            } else {
                this.setState({
                    processing: false,
                    failed: true
                })
            }
        });
    };

    render() {
        const { classes, onsuccess } = this.props;
        const steps = ['Create Pin', 'Organize pin'];
        const { activeStep, parentPin, newpin, pinOwner, amount } = this.state;
        const preventNext = !newpin.length || pinOwner.id === undefined;
        const isFormValid =
            newpin.length &&
            !isNaN(pinOwner.id) &&
            !isNaN(parentPin.pid) &&
            !isNaN(parentPin.ownrId);

        return (
            <div className={classes.root}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, ind) => {
                        return (
                            <Step key={ind}>
                                <StepButton
                                    onClick={() => this.handleStep(ind)}
                                >
                                    {label}
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>

                <div>
                    {this.state.activeStep === steps.length ? (
                        <SuccessMessage onsuccess={onsuccess} />
                    ) : (
                        <div>
                            {this.state.activeStep === 0 && (
                                <CreatePin
                                    goNext={this.handleNext}
                                    pin={newpin}
                                    personSelected={this.personSelected}
                                    pinOwner={pinOwner}
                                    preventNext={preventNext}
                                />
                            )}
                            {this.state.activeStep === 1 && (
                                <div className={classes.tabContainer}>
                                <UsePin
                                    pin={newpin}
                                    pinOwner={this.state.pinOwner}
                                    parentPin={this.state.parentPin}
                                    parentPins={this.state.selectPinOpts}
                                    pinSelected={this.pinSelected}
                                />
                                <NumberPreview 
                                    amount={amount}
                                    change={this.handleChange('amount')}
                                />
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {activeStep === 1 && parentPin.pid !== undefined && amount > 0 && (
                    <Grid className={classes.marginTop} container>
                        <Grid style={{ marginLeft: 'auto' }} item>
                            { this.state.failed && <MsgError msg="Process Failed"/> }
                            <ButtonSubmit
                                label="Save"
                                submitFn={this.submit}
                                processing={this.state.processing}
                                formFilled={isFormValid}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

PinStepper.propTypes = {
    classes: PropTypes.object,
};

export default withStyles(styles)(PinStepper);

class UsePin extends React.Component {
    render() {
        const {
            pin,
            pinOwner,
            parentPin,
            parentPins,
            pinSelected,
        } = this.props;

        return (
            <div>
                <Grid container justify="space-between">
                    <Grid item>
                        <Typography variant="body2">
                            Pin on down: {pin}{' '}
                        </Typography>
                        <Typography variant="caption">
                            Owner: {pinOwner.name}
                        </Typography>
                    </Grid>
                    {parentPin.pid !== undefined && (
                        <Grid item>
                            <Typography variant="body2">
                                Pin on top: {parentPin.pin}
                            </Typography>
                            <Typography variant="caption">
                                Owner: {parentPin.ownr}
                            </Typography>
                        </Grid>
                    )}
                </Grid>

                <ReactSelect
                    options={parentPins}
                    label="Select Reference pin"
                    onSelected={pinSelected}
                />
            </div>
        );
    }
}

const greenColor = { color: '#008000' };
    const SuccessMessage = ({ onsuccess }) => (
    <div>
        <div
            style={{
                textAlign: 'center',
                padding: 10,
                backgroundColor: '#e6ffe6',
            }}
        >
            <Typography style={greenColor} variant="h5">
                Success
            </Typography>
            <Typography variant="body1" style={greenColor}>
                Pin added successfully.
            </Typography>
        </div>
        <Grid style={{ marginTop: 8 }} justify="flex-end" container>
            <Button variant="outlined" onClick={onsuccess}>
                Okay
            </Button>
        </Grid>
    </div>
);

const NumberPreview = ({amount, change}) => (
    <Grid justify="space-between" alignItems="flex-end" container>
        <Grid item>
            <FormControl fullWidth error={false}>
                <TextField
                    type="number"
                    value={amount}
                    onChange={change}
                    margin="dense"
                    label="Deposit Amount"
                    error={false}
                    fullWidth
                />
            </FormControl>
        </Grid>
        <Grid item>
            <Typography variant="h6">
                <Rupee amount={amount} />
            </Typography>
        </Grid>
    </Grid>
);
